import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FeatureConstants {
  static readonly QualityManagement = 'QualityManagementGroup.QualityManagement';
  static readonly SmartSampling = 'QualityManagementGroup.SmartSampling';
  static readonly UserFeedback = 'UserFeedbackGroup.UserFeedback';
  static readonly EvaluationDurationStopWatch =
    'QualityManagementGroup.EvaluationDurationStopWatch';
  static readonly Analytics = 'AnalyticsGroup.Analytics';
  static readonly ConversationSummarization = 'AnalyticsGroup.ConversationSummarization';
  static readonly FeatureNamedEntityRecognition = 'AnalyticsGroup.NamedEntityRecognition';
  static readonly LanguageDetection = 'AnalyticsGroup.LanguageDetection';
  static readonly AskGenAi = 'AnalyticsGroup.AskGenAi';
  static readonly FeatureGenAITag = 'AnalyticsGroup.FeatureGenAITag';
  static readonly FeatureGenAICategory = 'AnalyticsGroup.FeatureGenAICategory';
  static readonly CallRecorder = 'CallRecorderGroup.CallRecorder';
  static readonly GenesysIntegration = 'MarketPlaceIntegrationGroup.GenesysIntegration';
  static readonly GenesysIntegrationOutOfMarketplace =
    'MarketPlaceIntegrationGroup.GenesysIntegrationOutOfMarketplace';
  static readonly GenesysGIRIntegration = 'MarketPlaceIntegrationGroup.GenesysGIRIntegration';
  static readonly ZoomMeetingIntegration = 'MarketPlaceIntegrationGroup.ZoomMeetingIntegration';
  static readonly ZoomContactCenterIntegration =
    'MarketPlaceIntegrationGroup.ZoomContactCenterIntegration';
  static readonly AloTechIntegration = 'MarketPlaceIntegrationGroup.AloTechIntegration';
  static readonly AloTechV3Integration = 'MarketPlaceIntegrationGroup.AloTechV3Integration';
  static readonly PuzzelIntegration = 'MarketPlaceIntegrationGroup.PuzzelIntegration';
  static readonly ZendeskIntegration = 'MarketPlaceIntegrationGroup.ZendeskIntegration';
  static readonly AmazonIntegration = 'MarketPlaceIntegrationGroup.AmazonIntegration';
  static readonly AmazonS3Integration = 'MarketPlaceIntegrationGroup.AmazonS3Integration';
  static readonly AmazonIntegrationOutOfMarketplace = 'MarketPlaceIntegrationGroup.AmazonIntegrationOutOfMarketplace';
  static readonly TeamsIntegration = 'MarketPlaceIntegrationGroup.TeamsIntegration';
  static readonly TwilioIntegration = 'MarketPlaceIntegrationGroup.TwilioIntegration';
  static readonly Five9Integration = 'MarketPlaceIntegrationGroup.Five9Integration';
  static readonly NiceIntegration = 'MarketPlaceIntegrationGroup.NiceIntegration';
  static readonly DynamicsIntegration = 'MarketPlaceIntegrationGroup.DynamicsIntegration';
  static readonly DataFeederGroup = 'MarketPlaceIntegrationGroup.DataFeederGroup';
  static readonly RealTime = 'RealTimeGroup.RealTime';
  static readonly ConversationSimulation = 'CoachingAndTraining.ConversationSimulation';
  static readonly CoachingDashboard = 'CoachingAndTraining.CoachingDashboard';
  static readonly ScreenRecorder = 'ScreenRecorderGroup.ScreenRecorder';
  static readonly ExternalLogin = 'ExternalLoginGroup.ExternalLogin';
  static readonly CallType = 'FeatureCallTypeGroup.FeatureCallType';
  static readonly ChatType = 'FeatureChatTypeGroup.FeatureChatType';
  static readonly VideoCallType = 'FeatureVideoCallTypeGroup.FeatureVideoCallType';
  static readonly MeetingType = 'FeatureMeetingTypeGroup.FeatureMeetingType';
  static readonly EmailType = 'FeatureEmailTypeGroup.FeatureEmailType';
  static readonly UserNamedLicensing = 'LicensingFeatureGroup.UserNamedLicensing';
  static readonly LdapLogin = 'Account.EnableLdapLogin';
  static readonly PremiumReporting = 'PremiumReportingGroup.PremiumReporting';
  static readonly GenerativeAI = 'GenerativeAIIntegrationGroup.GenerativeAIIntegration';
  static readonly GenerativeQA = 'RealTimeGroup.GenerativeQA';
  static readonly VirtualAgentIntegration = 'RealTimeGroup.VirtualAgentIntegration';
  static readonly VirtualTranslatorIntegration = 'FeatureVirtualTranslator';
  static readonly GenesysVirtualTranslatorIntegration =
    'MarketPlaceIntegrationGroup.GenesysVirtualTranslatorIntegration';
  static readonly GenesysVirtualTranslatorIntegrationOutOfMarketplace =
    'MarketPlaceIntegrationGroup.GenesysVirtualTranslatorIntegrationOutOfMarketplace';
  static readonly VoiceBiometricsIntegration = 'RealTimeGroup.VoiceBiometricsIntegration';
  static readonly PrivacyFeatureGroup = 'PrivacyFeatureGroup';
  static readonly FeatureUserAnonymization =
    FeatureConstants.PrivacyFeatureGroup + '.UserAnonymization';
  static readonly PerformanceInsights = 'RealTimeGroup.FeaturePerformanceInsights';
  static readonly FeedbackForNotifications = 'RealTimeGroup.FeatureFeedbackForNotifications';
  static readonly SentimentBasedNotifications = 'RealTimeGroup.FeatureSentimentBasedNotifications';
  static readonly EmotionBasedNotifications = 'RealTimeGroup.FeatureEmotionBasedNotifications';
  static readonly CoachingAndTraining = 'CoachingAndTraining.CoachingAndTraining';
  static readonly AIEvaluator = 'QualityManagementGroup.AiEvaluator';
}
